import { Observable } from 'rxjs';
import { ProveedorServicio } from '../interfaces/proveedor-servicios';


export abstract class ProveedorService {

    abstract getProveedores(): Observable<ProveedorServicio[]>;
}